interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  className?: string;
  variant?: 'default' | 'dots' | 'pulse';
}

export const LoadingSpinner = ({ 
  size = 'md', 
  message, 
  className = '',
  variant = 'default'
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8'
  };

  const renderSpinner = () => {
    switch (variant) {
      case 'dots':
        return (
          <div className="flex space-x-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className={`${sizeClasses[size]} bg-solr-nebula-purple rounded-full animate-pulse`}
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>
        );
      case 'pulse':
        return (
          <div className={`${sizeClasses[size]} bg-solr-nebula-purple rounded-full animate-pulse`} />
        );
      default:
        return (
          <div 
            className={`${sizeClasses[size]} border-2 border-solr-nebula-purple border-t-transparent rounded-full animate-spin`}
            role="status"
            aria-label="Loading"
          />
        );
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`} role="status" aria-live="polite">
      {renderSpinner()}
      {message && (
        <p className="mt-2 text-sm text-solr-starfield-white/70" aria-live="polite">
          {message}
        </p>
      )}
      <span className="sr-only">Loading...</span>
    </div>
  );
};

// Loading overlay for full-screen loading states
export const LoadingOverlay = ({ message = 'Loading...' }: { message?: string }) => (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
    <div className="bg-solr-void-black/90 border border-solr-nebula-purple rounded-lg p-6 backdrop-blur-sm">
      <LoadingSpinner size="lg" message={message} />
    </div>
  </div>
);